"use strict";

// Replacement of no-js for js in html tag
document.documentElement.className = document.documentElement.className.replace('no-js', 'js'); // Detect mobile

var isMobile = false;
var userAgent = navigator.userAgent || navigator.vendor || window.opera;

if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(userAgent.substr(0, 4))) {
  isMobile = true;
  document.documentElement.className = document.documentElement.className.replace('is-desktop', 'is-mobile');
} // Detect touch


var isTouch = false;
window.addEventListener('touchstart', function onFirstTouch() {
  isTouch = true;
  document.documentElement.className = document.documentElement.className.replace('no-touch', 'touch'); // We only need to know once that a human touched the screen, so we can stop listening now

  window.removeEventListener('touchstart', onFirstTouch, false);
}, false); // ScrollMagic controller

var pageScroll = new ScrollMagic.Controller(); // When page ready

jQuery(pageReady);

function pageReady($) {
  // Get baseurl and page language
  var baseUrl = $('base').attr('href');
  var $html = $('html');
  var language = $html.attr('lang');
  var $body = $html.find('body');
  var $window = $(window); // Window size

  var windowSizes = {
    width: 0,
    height: 0,
    change: false
  };

  function getWindowSizes() {
    var newWidth = parseInt($window.width());
    var newHeight = parseInt($window.height());
    var change;

    if (newWidth !== windowSizes.width && newHeight !== windowSizes.height) {
      change = 'both';
    } else if (newWidth !== windowSizes.width) {
      change = 'width';
    } else if (newHeight !== windowSizes.height) {
      change = 'height';
    } else {
      change = 'none';
    }

    windowSizes = {
      width: $window.width(),
      height: $window.height(),
      change: change
    };
  }

  getWindowSizes();
  $window.on('resize', getWindowSizes); // Parallax

  if (!isMobile) {
    $('[data-para]').each(function () {
      var $this = $(this); // Get effect (in pixels)

      var effect = parseInt($this.data('para')); // Get effect decal (in pixels)

      var decal = parseInt($this.data('decal'));

      if (!decal) {
        decal = 0;
      } // Get effect parent if exist


      var $parent = $this.data('parent');

      if ($parent) {
        $parent = $this.parents($parent);
      } else {
        $parent = $this;
      } // Element offset calculation


      var offset = $parent.offset().top - ($(window).height() - $parent.height()) / 2 - $(window).height(); // Window ratio calculation (adapt effect size for each windows height)

      var windowHeight = $(window).height();
      var windowRatio = windowHeight / 1000;
      effect = effect * windowRatio;
      decal = decal * windowRatio; // Apply effect

      gsap.set($this, {
        y: '+=' + effect * -1 / 2,
        x: '+=' + decal * -1 / 2
      });
      new ScrollMagic.Scene({
        offset: offset,
        duration: windowHeight * 2
      }).setTween(this, {
        y: '+=' + effect,
        x: '+=' + decal,
        ease: Power0.easeNone
      }).addTo(pageScroll);
    });
  } // Scrolled class


  function pageScrolled() {
    var scrollTop = $window.scrollTop();

    if (scrollTop > 50) {
      $body.addClass('scrolled');
    } else {
      $body.removeClass('scrolled');
    }
  }

  pageScrolled();
  $window.scroll(pageScrolled);
  $window.on('load', pageScrolled); // Cookie manager

  var $cookiesBar = $('.plmt-cookies-bar');

  if ($cookiesBar.length) {
    // Get cookies bar open size
    var plmtCookiesBarWH = function plmtCookiesBarWH() {
      if (cookiesState) {
        $cookiesBar.removeClass('closed');
      }

      initialWidth = $cookiesBar.outerWidth();
      initialHeight = $cookiesBar.outerHeight();

      if (cookiesState) {
        $cookiesBar.addClass('closed');
      }
    };

    // Close cookies bar if state is defined
    var plmtCookiesBarUpdate = function plmtCookiesBarUpdate() {
      cookiesState = Cookies.get('plmt-cookies-state');

      if (cookiesState) {
        var cookiesTl = gsap.timeline({
          onComplete: function onComplete() {
            $cookiesBar.addClass('closed');
            gsap.set($cookiesBar, {
              clearProps: 'all'
            });
            gsap.set($cookiesBar.find('> *'), {
              clearProps: 'all'
            });
          }
        });
        cookiesTl.set($cookiesBar, {
          width: initialWidth,
          height: initialHeight
        });
        cookiesTl.set($cookiesBar.find('.plmt-cookies-bar-inner,.plmt-cookies-bar-btns'), {
          display: 'none'
        });
        cookiesTl.set($cookiesBar.find('.plmt-cookies-bar-open'), {
          display: 'block',
          autoAlpha: 0
        });
        cookiesTl.to($cookiesBar, {
          width: '60px',
          height: '60px',
          borderRadius: '60px',
          duration: 0.3
        });
        cookiesTl.to($cookiesBar.find('.plmt-cookies-bar-open'), {
          autoAlpha: 1,
          duration: 0.3
        }, 0.1);
      }
    }; // Essential btn


    var cookiesState = Cookies.get('plmt-cookies-state');
    var initialWidth, initialHeight;
    plmtCookiesBarWH();
    $window.resize(plmtCookiesBarWH);
    $cookiesBar.on('click', 'button.essential', function () {
      if (!$cookiesBar.hasClass('closed')) {
        Cookies.set('plmt-cookies-state', 'essential', {
          expires: 365
        });
        plmtCookiesBarUpdate();
      }
    }); // All btn

    $cookiesBar.on('click', 'button.all', function () {
      if (!$cookiesBar.hasClass('closed')) {
        Cookies.set('plmt-cookies-state', 'all', {
          expires: 365
        });
        plmtCookiesBarUpdate();
      }
    }); // Open btn

    $cookiesBar.on('click', '.plmt-cookies-bar-open button', function () {
      if ($cookiesBar.hasClass('closed')) {
        var cookiesTl = gsap.timeline({
          onComplete: function onComplete() {
            $cookiesBar.removeClass('closed');
            gsap.set($cookiesBar, {
              clearProps: 'all'
            });
            gsap.set($cookiesBar.find('> *'), {
              clearProps: 'all'
            });
          }
        });
        cookiesTl.to($cookiesBar.find('.plmt-cookies-bar-open'), {
          autoAlpha: 0,
          duration: 0.3
        });
        cookiesTl.to($cookiesBar, {
          width: initialWidth,
          height: initialHeight,
          borderRadius: '3px',
          duration: 0.3
        }, 0.1);
        cookiesTl.set($cookiesBar.find('.plmt-cookies-bar-inner,.plmt-cookies-bar-btns'), {
          autoAlpha: 0,
          display: 'block'
        }, 0.4);
        cookiesTl.to($cookiesBar.find('.plmt-cookies-bar-inner,.plmt-cookies-bar-btns'), {
          autoAlpha: 1,
          duration: 0.3
        }, 0.4);
      }
    });
  } // Intro title


  var $pageIntroTitle = $('.intro-title-pre');

  if ($pageIntroTitle.length) {
    var decal = parseInt($pageIntroTitle.width()) / 2 - parseInt($pageIntroTitle.width());
    gsap.set('.intro-title,.intro-title-pre', {
      left: '50%',
      x: decal,
      autoAlpha: 1
    });
    gsap.from('.intro-title,.intro-title-pre', {
      yPercent: 100,
      autoAlpha: 0,
      duration: 1,
      ease: Power0.easeNone
    });
  } // Intro arrow


  var $pageIntroArrow = $('.intro-arrow');

  if ($pageIntroArrow.length) {
    gsap.set($pageIntroArrow, {
      y: 50
    });
    gsap.from($pageIntroArrow, {
      y: 0,
      repeat: -1,
      autoAlpha: 0,
      duration: 1,
      repeatDelay: 0.5
    });
  } // Newsletter form


  var $newsletterForm = $('.footer-newsletter form');

  if ($newsletterForm.length) {
    var $submitBtn = $newsletterForm.find('button[type=submit]');
    var $errorLine = $newsletterForm.find('.error-line');
    $newsletterForm.submit(function (e) {
      // Prevent default submit
      e.preventDefault(); // Deactivate buttons

      $submitBtn.prop('disabled', true); // Change submit button text

      $submitBtn.data('oldText', $submitBtn.text()).text($submitBtn.data('send')); // Send form in ajax

      jQuery.ajax({
        method: 'POST',
        url: ajax.url,
        dataType: 'json',
        data: {
          form: $newsletterForm.serialize(),
          action: 'plmt-newsletter-form',
          security: ajax.nonce
        },
        success: function success(data) {
          // Set message
          var $error;

          if (data.success) {
            $error = jQuery('<div class="alert alert-success">' + data.success + '</div>'); // Reset form

            $newsletterForm.trigger('reset');
            $newsletterForm.find('.input-line.upload .upload-hidden').val('');
            $newsletterForm.find('.input-line.upload .upload-name').remove();
          } else if (data.error) {
            $error = jQuery('<div class="alert alert-warning" role="alert">' + data.error + '</div>');
          }

          $errorLine.empty().append($error);
          gsap.from($error, {
            duration: 0.3,
            autoAlpha: 0,
            y: 20
          }); // Enable submit

          $submitBtn.prop('disabled', false); // Reset submit button text

          $submitBtn.text($submitBtn.data('oldText'));
        }
      });
    });
  } // Resp menu


  var $respBtn = $('.resp-btn');

  if ($respBtn.length) {
    $respBtn.click(function () {
      if ($body.hasClass('resp-open')) {
        $body.toggleClass('resp-open');
        gsap.set('header', {
          clearProps: 'all'
        });
      } else {
        $body.toggleClass('resp-open');
        gsap.from('header', {
          autoAlpha: 0
        });
      }
    }); // Open sub

    $('header > nav > ul > li.menu-item-has-children > a').click(function (e) {
      if ($window.width() < 1310) {
        e.preventDefault();
        var $this = $(this).parent();
        var $ul = $this.find('ul');

        if (!$this.hasClass('open')) {
          $this.addClass('open');
          gsap.set($ul, {
            clearProps: 'all'
          });
          gsap.from($ul, {
            height: 0,
            padding: 0,
            margin: 0
          });
        }
      }
    }); // Close sub

    $('header > nav > ul > li > ul').click(function (e) {
      if ($window.width() < 1310) {
        var $this = $(this);

        if (e.offsetY < 30 && $this.width() - e.offsetX < 50) {
          $this.parent().removeClass('open');
          gsap.set($this, {
            clearProps: 'all'
          });
        }
      }
    });
  } // Pjax for tabs


  var $fipacoTabs = $('.plmb-fipaco-tabs ul li a');

  if ($fipacoTabs.length) {
    var pjax = new Pjax({
      elements: '.plmb-fipaco-tabs ul li a',
      // default is "a[href], form[action]"
      selectors: ['title', '.blocks-container', '#wpadminbar'],
      scrollTo: false
    });
    document.addEventListener('pjax:send', function () {//gsap.set( '.blocks-container', { autoAlpha: 0 } );
    });
    document.addEventListener('pjax:complete', function () {
      var $blocksContainer = $('.blocks-container'); // Init blocks

      blockInitFSimuCapa($blocksContainer);
      blockInitFSimuCredit($blocksContainer);
      blockInitFSlides($blocksContainer); // Animate
      //gsap.to( $blocksContainer, { duration: 0.2, autoAlpha: 1 } ); // Animate
    });
  }
} // When page loaded


jQuery(window).load(onLoad);

function onLoad() {
  var $ = jQuery;
}
//# sourceMappingURL=front.js.map
